import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { IMPORT_SUMMARY_CONST } from '../../../control-plane/constants';
import { postImportJourneySummary } from '../actions/actionType/ImportJourneySummaryActionType';
import {
  clearImportJourneySummarys,
  fetchImportJourneySummaryFailure,
  fetchImportJourneySummaryStarted,
  fetchImportJourneySummarySuccess
} from '../actions/sagaActions/ImportJourneySummarySagaActions';
import { FetchImportJourneySummaryFailPayload, FetchImportJourneySummaryRequest } from '../actions/types/ImportAllJourneySummaryTypes';

export async function callImportJourneyApi(data: FormData) {
  return apiWrapper.post<string>(
    `${process.env.REACT_APP_API_BASE_URL}/exim/import?recordType=${IMPORT_SUMMARY_CONST.journey}`,
    data,
    {},
    'multipart/form-data',
  );
}
export function* postImportJourneyApi({
  fileData,
}: FetchImportJourneySummaryRequest) {
  yield put(clearImportJourneySummarys());
  yield put(fetchImportJourneySummaryStarted());
  try {
    const { responseBody: data, isError, error } = yield call(callImportJourneyApi, fileData);
    if (isError) {
      throw error;
    }
    // put length check here
    if (data) {
      yield put(fetchImportJourneySummarySuccess(data));
    } else {
      throw new Error('No Response');
    }
  } catch (error: any) {
    const obj: FetchImportJourneySummaryFailPayload = {
      errorCode: String(error?.response?.data.error_code),
      errorMessage: String(error?.response?.data?.errorMessage)
    };
    yield put(fetchImportJourneySummaryFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* importJourneySummarySaga() {
  yield takeLatest(postImportJourneySummary.POST_IMPORT_JOURNEY_SUMMARY_REQUEST, postImportJourneyApi);
}

export const importJourneySummarySagaHandler = [fork(importJourneySummarySaga)];
